import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
// 共三个页面： 聊天页面，好友页面，个人简历分别对应一下路由
  routes: [
    // 默认路由重定向到登录页面
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      component: () => import('@/page/login/login.vue')
    },
    {
      path: '/chat',
      component: () => import('@/page/chat/chat.vue')
    },
    // {
    //   path: '/friend',
    //   component: () => import('@/page/friend/friend.vue')
    // },
    // {
    //   path: '/my',
    //   component: () => import('@/page/resume/resume.vue')
    // }
  ],
  linkActiveClass: 'active'
})


// 添加路由守卫
router.beforeEach((to, from, next) => {
  console.log('路由守卫 - 目标路径:', to.path);
  console.log('路由守卫 - 查询参数:', to.query);
  // 检查是否已登录
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
  console.log('路由守卫 - 登录状态:', isLoggedIn);

 console.log('路由守卫 - 正常跳转');
    next();
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js